import { Component, Inject, OnInit } from '@angular/core';
import { TlkModalWindowRef, TLK_MODAL_WINDOW_DATA, TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { ConfirmationPopUpInput } from '@shared/models/confirmation-pop-up-input';
import { PopUpActions } from '@shared/models/enums/popup-modal-actions.enum';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { TlkCheckboxComponent } from '@itero/ui-toolkit-angular/checkbox';
import { NgStyle, NgIf } from '@angular/common';

@Component({
	selector: 'rx-confirmation-pop-up',
	templateUrl: './confirmation-pop-up.component.html',
	styleUrls: ['./confirmation-pop-up.component.scss'],
	standalone: true,
	imports: [
		TlkModalWindowModule,
		TlkButtonComponent,
		NgStyle,
		NgIf,
		TlkCheckboxComponent,
		FormsModule,
		TranslateModule
	]
})
/**
 * @deprecated Use ConfirmationDialogComponent from @shared/components/toolkit-confirmation-dialog/confirmation-dialog.component instead.
 */
export class ConfirmationPopUpComponent implements OnInit {
	popUpActions = PopUpActions;
	iconSrc: string;
	private defaultIconName = 'information-icon';
	dontShowAgain = false;
	isDontShowAgainVisible = !!this.dialogInput.dontShowAgainAction;
	showCancelButton = !this.dialogInput.hideCancelButton;

	constructor(
		public dialogRef: TlkModalWindowRef<PopUpActions, ConfirmationPopUpComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public dialogInput: ConfirmationPopUpInput,
		private shellQuery: ShellQuery
	) {}

	ngOnInit(): void {
		const iconName = this.dialogInput.iconName ?? this.defaultIconName;

		this.iconSrc = `${this.shellQuery.staticFilesEndpoint}/assets/icons/${iconName}.png`;
	}

	close(action: PopUpActions): void {
		this.dialogRef.close(action);
	}
}
